module.exports = __webpack_public_path__ + "static/media/codemessgae.32ea3a6c.svg";